import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text,
    InputGroup, InputRightElement, Icon, IconButton,
    Stack, HStack, Image, VStack,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, Textarea, useToast
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { MdSave, MdClose } from 'react-icons/md';
import { Form, Field } from 'react-final-form';
import { isNil } from 'lodash';
import axios from 'axios';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { WORK_DAILY_LIST, ERROR_CODES } from '../../../constants';

import DropZoneWithImage from '../../../components/DropZoneWithImage';

function AddEditDoctorModal({ 
    company_id, doctorDetail, systemSettingDetail, actionStatus, initialRef, isOpen, onClose, 
    apiCreateNewDoctor, apiUpdateADoctor, apiLoadASystemSettingByCompanyId 
}) {
    const [ portraitFile, setPortraitFile ] = useState(null);
    const [ fromTime, setFromTime ] = useState("07:00");
    const [ toTime, setToTime ] = useState("16:00");
    const [ workDailyList, setWorkDailyList ] = useState([]);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const [ cookies ] = useCookies(["loginCookie"]);
    const mounted = useRef();
    const toast = useToast();

    useEffect(() => {
        if(!mounted.current) {
            apiLoadASystemSettingByCompanyId({ company_id });
            mounted.current = true;
        }
    });

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    useEffect(() => {
        const _WORK_DAILY_LIST = systemSettingDetail?.daily_time_schedules?.work_daily || WORK_DAILY_LIST;
        const _workDailyList = [];
        
        Object.keys(_WORK_DAILY_LIST).map(key => {
            if(_WORK_DAILY_LIST[key]) {
                _workDailyList.push({
                    label: key,
                    value: key
                })
            }
        })
        setWorkDailyList(_workDailyList);
    }, [systemSettingDetail]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.specialist) {
            errors.specialist = "Required";
        }
        // if(!values.phone) {
        //     errors.phone = "Required";
        // }
        if(!values.work_daily || values.work_daily && values.work_daily?.length === 0) {
            errors.work_daily = "Required";
        }
        
        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        try
        {
            let portrait_url = null;

            if(!isNil(portraitFile)) {
                // upload portrait
                let portraitFiledata = new FormData();
                portraitFiledata.append('uri', portraitFile);

                let resUpload = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/upload?subPath=doctors`, portraitFiledata, { 
                    headers: { "Content-Type": "multipart/form-data" },
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                if(resUpload.data?.status === 200) {
                    portrait_url = resUpload.data.fileName;
                }
            }

            if(doctorDetail && doctorDetail.id) {
                apiUpdateADoctor({ 
                    id: doctorDetail.id, 
                    payload: {
                        ...values,
                        portrait_url: portrait_url || doctorDetail?.portrait_url,
                        from_time: fromTime,
                        to_time: toTime,
                        user_id: cookies?.loginCookie?.data?.id,   
                    } 
                });
            } else {
                apiCreateNewDoctor({ 
                    ...values,
                    portrait_url,
                    from_time: fromTime,
                    to_time: toTime,
                    user_id: cookies?.loginCookie?.data?.id,    
                });
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="xxl">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...doctorDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { doctorDetail && doctorDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} align="flex-start">
                                        <VStack width={{ base: "100%", md: "100%", lg: "50%" }} px={2}>
                                            <Field name="name">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Tên - chức danh</FormLabel>
                                                        <Input {...input} type='text' placeholder='Nhập tên - chức danh' />
                                                    </FormControl>
                                                )}
                                            </Field>
                                            
                                            <Field name="specialist">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Chuyên khoa</FormLabel>
                                                        <Input {...input} type='text' placeholder='Nhập chuyên khoa' />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="work_daily">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Ngày làm việc</FormLabel>
                                                        <Select 
                                                            {...input} 
                                                            isMulti
                                                            options={workDailyList}
                                                            closeMenuOnSelect={false}
                                                        />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="phone">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel>Số Điện Thoại</FormLabel>
                                                        <Input {...input} type='text' placeholder='Nhập số điện thoại' />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="address">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel>Địa chỉ</FormLabel>
                                                        <Input {...input} type='text' placeholder='Nhập địa chỉ' />
                                                    </FormControl>
                                                )}
                                            </Field>
                                            
                                            <FormControl>
                                                <FormLabel>Ảnh đại diện</FormLabel>
                                                <HStack>
                                                    {
                                                        doctorDetail?.portrait_url && !portraitFile &&
                                                        <Image alt="logo" src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/doctors/${doctorDetail?.portrait_url}`} 
                                                            maxW="200px" maxH="200px"
                                                        />
                                                    }
                                                    <DropZoneWithImage callback={setPortraitFile} />
                                                </HStack>
                                            </FormControl>
                                        </VStack>
                                            
                                        <VStack width={{ base: "100%", md: "100%", lg: "50%" }} px={2}>
                                            <Field name="education">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel>Học vấn</FormLabel>
                                                        <Textarea {...input} placeholder='Nhập học vấn' />
                                                    </FormControl> 
                                                )}
                                            </Field>

                                            <Field name="experience">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel>Kinh nghiệm công tác</FormLabel>
                                                        <Textarea {...input} placeholder='Nhập kinh nghiệm công tác' />
                                                    </FormControl> 
                                                )}
                                            </Field>
                                            
                                            <Flex w="100%">
                                                <FormControl maxW="250px">
                                                    <FormLabel>Thời gian làm việc bắt đầu</FormLabel>
                                                    <TimePicker 
                                                        onChange={setFromTime}
                                                        value={fromTime}
                                                    />
                                                </FormControl>

                                                <FormControl maxW="250px">
                                                    <FormLabel>Thời gian làm việc kết thúc</FormLabel>
                                                    <TimePicker 
                                                        onChange={setToTime}
                                                        value={toTime}
                                                    />
                                                </FormControl>
                                            </Flex>

                                            <Field name="description">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel>Mô tả thêm</FormLabel>
                                                        <Textarea {...input} placeholder='Nhập mô tả thêm' />
                                                    </FormControl> 
                                                )}
                                            </Field>
                                        </VStack>
                                    </Flex>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditDoctorModal;